export default __webpack_public_path__ + "slices/main/assets/public/media/ca_21q2haw_toolkit3_ebook_cover.973cf45ac1bd930749bb7f3400de9033.png";